<template>
  <ModalUi @closeModal="closeConnection">
    <div class="modal-wrap">
      <div class="modal-block">
        <div class="modal-title">
          <h3>Привязка карты</h3>
        </div>
        <button class="close" @click="closeConnection" type="button">
          <img src="/images/redesignedForm/close-button.svg" alt="close" />
        </button>

        <div class="modal-content">
          <iframe
            title="cart"
            v-show="!isLoading"
            class="payment__iframe"
            v-if="isShowIframe === true"
            :src="socket.paymentUrl"
            frameborder="0"
            @load="load"
          ></iframe>
          <div class="payment__iframe flex-column" v-show="isLoading">
            <img src="/images/loading-orange.gif" alt="loading" />
            <div v-if="isShowErrorMessage">Пробуем соединиться с сервером.</div>
          </div>
        </div>
      </div>
    </div>
  </ModalUi>
</template>

<script>
import bindNewCardMixin from '@apps/order-form/src/mixins/bindNewCard'
import ModalUi from '@features/UI/ModalUi.vue'

export default {
  name: 'BindNewCard',
  mixins: [bindNewCardMixin],
  components: { ModalUi },
}
</script>

<style lang="scss" scoped>
.payment__iframe {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 67vh;

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.modal-block {
  height: 78vh !important;
  max-height: none !important;
}

.loader {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
}
</style>
